import React, { createContext, useContext, useMemo } from "react"

export interface GraphPropContextType {
  l: number
  lm: number
  pmin: number
  pmax: number
}

export const GraphPropContext = createContext<GraphPropContextType | undefined>(undefined)
GraphPropContext.displayName = "GraphPropContext"

export interface GraphPropContextProviderProps {
  width: number
  pmin?: number
  pmax?: number
  children?: React.ReactNode
}

export const GraphPropContextProvider: React.FC<GraphPropContextProviderProps> = (props) => {
  const ctx = useMemo<GraphPropContextType>(() => {
    return {
      l: props.width,
      lm: Math.ceil(props.width / 2),
      pmin: props.pmin,
      pmax: props.pmax || 0,
    }
  }, [props])
  return <GraphPropContext.Provider value={ctx}>{props.children}</GraphPropContext.Provider>
}

export const useGraphPropContext = () => useContext(GraphPropContext)
